/**
 * MetricTile — a small inline figure (label + value) used inside section cards.
 */

import React from 'react';
import type {AnalyticsTone} from '../models/homeAnalytics.model';
import {toneStyle} from '../utils/toneStyles';

interface MetricTileProps {
  label: string;
  value: number | string;
  tone?: AnalyticsTone;
}

const MetricTile: React.FC<MetricTileProps> = ({
  label,
  value,
  tone = 'neutral'
}) => (
  <div className={`rounded-lg px-3 py-2 ${toneStyle(tone).softBg}`}>
    <div className={`text-lg font-bold ${toneStyle(tone).text}`}>
      {typeof value === 'number' ? value.toLocaleString('en-US') : value}
    </div>
    <div className="text-xs text-gray-500 truncate">{label}</div>
  </div>
);

export default MetricTile;
